module.exports = __webpack_public_path__ + "img/img18.b0f0172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img18.png
// module id = 194
// module chunks = 0